<ng-container *ngIf="fieldOrLabel | asLabelPipe as label; else AsField">
  <!-- <app-c-label [label]="label"></app-c-label> -->
   <app-c-label 
  [label]="label"
  [forms]="forms"
  [display]="display">
</app-c-label>
</ng-container>
<ng-template #AsField>
  <ng-container *ngIf="fieldOrLabel | asFieldPipe as field">
    <ng-container *ngIf="mainFormOrSubForm === 'main-form'">
      <ng-container *ngIf="(forms | getFieldInFormPipe:step:bloc:fieldOrLabel) as formControl" [ngTemplateOutlet]="Control" [ngTemplateOutletContext]="{formControl:formControl, field: field}"></ng-container>
      <ng-container *ngIf="(forms | getArrayInFormPipe:step:bloc:fieldOrLabel) as formArray" [ngTemplateOutlet]="CasesDynamiques" [ngTemplateOutletContext]="{formArray:formArray, field: field}"></ng-container>
    </ng-container>
    <ng-container *ngIf="mainFormOrSubForm === 'sub-form'">
      <ng-container *ngIf="(forms.controls[field.name] | asFormControlPipe) as formControl" [ngTemplateOutlet]="Control" [ngTemplateOutletContext]="{formControl:formControl, field: field}"></ng-container>
      <ng-container *ngIf="(forms.controls[field.name] | asFormArrayPipe) as formArray" [ngTemplateOutlet]="CasesDynamiques" [ngTemplateOutletContext]="{formArray:formArray, field: field}"></ng-container>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #Control let-formControl="formControl" let-field="field">
  <app-c-field-status [display]="display" [field]="field" [cFormControl]="formControl" [forms]="forms" [previousField]="true">

    <ng-container *ngIf="field | asCheckboxPipe as checkboxField; else asRadio">
      <ng-container *ngIf="checkboxField.labelType === 'html'; else CheckBoxLabelText">
        <app-c-checkbox-label-html [field]="checkboxField" [cFormControl]="formControl" [blocName]="blocName" [disabledField]="modeShow" [looksDisabled]="true" (triggerAlert)="cascadeTriggerAlert($event)" [noLabel]="true" [etatId]="etatId"></app-c-checkbox-label-html>
      </ng-container>
      <ng-template #CheckBoxLabelText>
        <app-c-checkbox [field]="checkboxField" [cFormControl]="formControl" [blocName]="blocName" [disabledField]="modeShow" [looksDisabled]="true" (triggerAlert)="cascadeTriggerAlert($event)" [noLabel]="true" [etatId]="etatId"></app-c-checkbox>
      </ng-template>
    </ng-container>

    <ng-template #asRadio>
      <ng-container *ngIf="field | asRadioPipe as radioField; else AsTextArea">
        <ng-container *ngIf="radioField.labelType === 'html'; else RadioLabelText">
          <app-c-radio-label-html [field]="radioField" [cFormControl]="formControl" [blocName]="blocName" [disabledField]="modeShow" [looksDisabled]="true" (triggerAlert)="cascadeTriggerAlert($event)" [noLabel]="true"></app-c-radio-label-html>
        </ng-container>
        <ng-template #RadioLabelText>
          <app-c-radio [field]="radioField" [cFormControl]="formControl" [blocName]="blocName" [disabledField]="modeShow" [looksDisabled]="true" (triggerAlert)="cascadeTriggerAlert($event)" [noLabel]="true"></app-c-radio>
        </ng-template>
      </ng-container>
    </ng-template>

    <ng-template #AsTextArea>
      <ng-container *ngIf="field | asTextAreaPipe as textArea; else AsInputText">
        <app-c-textarea [field]="textArea" [cFormControl]="formControl" [blocName]="blocName" [disabledField]="modeShow" [looksDisabled]="true" (triggerAlert)="cascadeTriggerAlert($event)" [noLabel]="true"></app-c-textarea>
      </ng-container>
    </ng-template>

    <ng-template #AsInputText>
      <ng-container *ngIf="field | asInputTextPipe as inputTextField; else AsInputNumber">
        <app-c-inputtext [field]="inputTextField" [cFormControl]="formControl" [blocName]="blocName" [form]="forms" [disabledField]="modeShow" [looksDisabled]="true" (triggerAlert)="cascadeTriggerAlert($event)" [noLabel]="true" [etatId]="etatId"></app-c-inputtext>
      </ng-container>
    </ng-template>

    <ng-template #AsInputNumber>
      <ng-container *ngIf="field | asInputNumberPipe as inputNumberField; else AsDrawing">
        <app-c-inputtext [field]="inputNumberField" [cFormControl]="formControl" [blocName]="blocName" [form]="forms" [disabledField]="modeShow" [looksDisabled]="true" (triggerAlert)="cascadeTriggerAlert($event)" [noLabel]="true" [etatId]="etatId"></app-c-inputtext>
      </ng-container>
    </ng-template>

    <ng-template #AsDrawing>
      <ng-container *ngIf="field | asDrawingPipe as drawingField; else AsListe">
        <app-c-drawing [field]="drawingField" [cFormControl]="formControl" [blocName]="blocName" [asyncLabel]="drawingField.asyncLabel | asyncLabelPipe:display:forms" [disabledField]="modeShow" (triggerAlert)="cascadeTriggerAlert($event)"></app-c-drawing>
      </ng-container>
    </ng-template>

    <!-- TODO-pf? différencier les deux listes à terme -->
    <ng-template #AsListe>
      <ng-container *ngIf="field | asListePipe as listeField">
        <app-c-liste [field]="listeField" [cFormControl]="formControl" [blocName]="blocName" [disabledField]="modeShow" [looksDisabled]="true" (triggerAlert)="cascadeTriggerAlert($event)" [noLabelNoErrorMessage]="true" [selectTriggerScope]="step.id + '-' + bloc.id"></app-c-liste>
      </ng-container>
    </ng-template>
    <!--
    <ng-template #AsListUser>
      <ng-container *ngIf="field | asListUserPipe as listeField;">
        <app-c-liste [field]="listeField" [cFormControl]="formControl" [blocName]="blocName" [disabledField]="modeShow" [looksDisabled]="true" (triggerAlert)="cascadeTriggerAlert($event)" [selectTriggerScope]="step.id + '-' + bloc.id"></app-c-liste>
      </ng-container>
    </ng-template>
  -->

    <app-c-tooltip-button *ngIf="field.tooltip" c-field-tooltip [tooltip]="field.tooltip"></app-c-tooltip-button>

  </app-c-field-status>

</ng-template>


<ng-template #CasesDynamiques let-formArray="formArray" let-field="field">
  <ng-container *ngIf="field | asCasesDynamiquesPipe as casesDynamiquesField;">
    <ng-container *ngIf="context === 'preparation'">
      <app-c-cases-dynamiques-preparation [field]="casesDynamiquesField" [cFormArray]="formArray" [blocName]="blocName" [disabledField]="modeShow" (triggerAlert)="cascadeTriggerAlert($event)">
      </app-c-cases-dynamiques-preparation>
    </ng-container>
    <ng-container *ngIf="context === 'edition'">
      <app-c-cases-dynamiques-edition [field]="casesDynamiquesField" [cFormArray]="formArray" [blocName]="blocName" [disabledField]="modeShow" (triggerAlert)="cascadeTriggerAlert($event)">
      </app-c-cases-dynamiques-edition>
    </ng-container>

    <app-c-tooltip-button *ngIf="field.tooltip" c-field-tooltip [tooltip]="field.tooltip"></app-c-tooltip-button>
  </ng-container>

</ng-template>
